import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

const _EXPERIMENT_DESKTOP = 'test_meganav_tabs_desktop';
const _EXPERIMENT_MOBILE = 'test_meganav_tabs_mobile';

export const useNewMegaNavExperiment = () => {
  const isLargishAndUp = useIsLargishAndUp();

  const inDesktopExperiment = isLargishAndUp;

  const inMobileExperiment = !isLargishAndUp;

  const inExperiment = inDesktopExperiment || inMobileExperiment;

  return {inExperiment, inDesktopExperiment, inMobileExperiment};
};
